import { isEqual } from "lodash"
import { FormikValues } from "formik"
import { isLocal } from "./formatters"
import { getRoutingMethod } from "./configs"

export function assertNotNullable<T>(
  arg: T,
  msg: string = "Expected data missing",
  ...rest: any[]
): asserts arg is NonNullable<T> {
  if (arg === undefined) {
    console.error(msg, ...rest)
    throw new Error(msg)
  }
}

export function compareFormValues(x: FormikValues, y: FormikValues) {
  const currentValues = {
    ...x,
  }

  const newValues = {
    ...y,
  }
  // Exclude acknowledge
  delete currentValues.acknowledge
  delete newValues.acknowledge

  // Are the initial values the same as current values
  // console.log(currentValues, newValues)
  return !isEqual(currentValues, newValues)
}

export function getTypedKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof typeof obj>
}

export function isNotEmptyRecord<T extends Record<string, any>>(
  obj: T
): obj is NonEmptyRecord<T> {
  return Object.keys(obj).length > 0
}

export function indexOfNoStrict(arr: readonly string[], str: string) {
  return arr.indexOf(str)
}

export function appendSearchToUrl(base: string, search: string | null) {
  // Strip /app prefix as React Router handles basename automatically
  const cleanBase = base.replace(/^\/app/, "")

  // For local hash routing, don't append search params
  if (isLocal() && getRoutingMethod() === "hash") {
    return cleanBase
  }

  const trimmed = search?.replace(/^\?/, "")
  if (!trimmed) {
    return cleanBase
  }

  const separator = cleanBase.includes("?") ? "&" : "?"
  return `${cleanBase}${separator}${trimmed}`
}

export function rebalanceFormPath(accountIndex: number): string {
  return `/investments/rebalance-form?current=${accountIndex}`
}

export function changePlanFormPath(accountIndex: number): string {
  return `/investments/change-your-plan?current=${accountIndex}`
}

export function variationFormPath(accountIndex: number): string {
  return `/pension-and-payments/variation-form?current=${accountIndex}`
}
